// Recently opened records, kept on this device for "Jump back in" and the
// quick-find box. Nothing private: a name and where it lives.
import { useEffect } from "react";

export interface Recent {
	kind: "candidate" | "client" | "booking" | "vacancy";
	id: string;
	label: string;
	href: string;
	at: number;
}
const KEY = "crm-recent";
const MAX = 8;

export function recents(): Recent[] {
	try {
		const v = JSON.parse(localStorage.getItem(KEY) ?? "[]");
		return Array.isArray(v) ? (v as Recent[]) : [];
	} catch {
		return [];
	}
}

export function remember(r: Omit<Recent, "at">) {
	try {
		const next = [{ ...r, at: Date.now() }, ...recents().filter((x) => x.href !== r.href)].slice(0, MAX);
		localStorage.setItem(KEY, JSON.stringify(next));
	} catch {}
}

/** Call on a record page once its name is known. */
export function useRemember(r: Omit<Recent, "at"> | null) {
	const href = r?.href;
	const label = r?.label;
	const kind = r?.kind;
	const id = r?.id;
	useEffect(() => {
		if (kind && id && href && label) remember({ kind, id, label, href });
	}, [kind, id, href, label]);
}
